module.exports = __webpack_public_path__ + "static/media/order-history.50abdcf8.svg";